import Preferences from "../preferences";
import VolunteerSchedule from "./volunteer-schedule";
import { VolunteerSkillInterest } from "./volunteer-skill-interest";

export default class VolunteerPreferences extends Preferences {
  schedule: VolunteerSchedule;
  skillsAndInterests: VolunteerSkillInterest[];
  skillsHash = {};

  constructor(
    schedule: VolunteerSchedule,
    skills: VolunteerSkillInterest[] = []
  ) {
    super();
    if (!schedule) {
      schedule = new VolunteerSchedule();
    }

    this.schedule = schedule;
    this.skillsAndInterests = skills;
  }

  public findSkillOrInterestById(term: string): VolunteerSkillInterest {
    if (this.skillsHash[term]) {
      return this.skillsHash[term];
    }

    let sk = {
      selected: false,
      term: term,
      other: "",
    };

    this.skillsHash[term] = sk;
    return sk;
  }

  public hasCachedSkill(key: number): boolean {
    return !!this.skillsHash[key];
  }

  public addCachedSkill(sk: VolunteerSkillInterest): void {
    if (!this.skillsHash[sk.term]) {
      this.skillsHash[sk.term] = sk;
    }
  }

  public initSkillsCache(): void {
    for (let i = 0; i < this.skillsAndInterests.length; i++) {
      const x = this.skillsAndInterests[i];
      console.log(`Adding: ${x.term}`);
      this.addCachedSkill(x);
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/resource-management/volunteers/volunteer-preferences.ts